// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Tooltip = require("../../../reason/common/Tooltip.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
var UseShouldShowPropertyDetails = require("../Hooks/UseShouldShowPropertyDetails.bs.js");
var AgentPropertyLocation_property_graphql = require("../../../__generated__/AgentPropertyLocation_property_graphql.bs.js");
var AgentPropertyLocation_propertyLocation_graphql = require("../../../__generated__/AgentPropertyLocation_propertyLocation_graphql.bs.js");

var convertFragment = AgentPropertyLocation_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentPropertyLocation_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentPropertyLocation_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentPropertyLocation_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentPropertyLocation_property_graphql.node, convertFragment, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = AgentPropertyLocation_propertyLocation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

var PropertyLocationFragment_visibilityReason_decode = AgentPropertyLocation_propertyLocation_graphql.Utils.visibilityReason_decode;

var PropertyLocationFragment_visibilityReason_fromString = AgentPropertyLocation_propertyLocation_graphql.Utils.visibilityReason_fromString;

var PropertyLocationFragment = {
  visibilityReason_decode: PropertyLocationFragment_visibilityReason_decode,
  visibilityReason_fromString: PropertyLocationFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function AgentPropertyLocation$Address(props) {
  var visibilityRule = props.visibilityRule;
  var locationDisplay = props.locationDisplay;
  var address = props.address;
  var tmp;
  if (address !== undefined) {
    var exit = 0;
    if (visibilityRule !== undefined) {
      var exit$1 = 0;
      if (visibilityRule === "VISIBLE_TO_ALL" || visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF") {
        switch (visibilityRule) {
          case "VISIBLE_TO_ALL" :
              exit = 1;
              break;
          case "VISIBLE_TO_ACCOUNT_MEMBER" :
          case "VISIBLE_TO_TAN_STAFF" :
              exit$1 = 2;
              break;
          
        }
      } else {
        exit = 1;
      }
      if (exit$1 === 2) {
        var tmp$1;
        if (visibilityRule === "VISIBLE_TO_ALL" || visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF") {
          switch (visibilityRule) {
            case "VISIBLE_TO_ACCOUNT_MEMBER" :
                tmp$1 = " (only visible to you)";
                break;
            case "VISIBLE_TO_ALL" :
                tmp$1 = "";
                break;
            case "VISIBLE_TO_TAN_STAFF" :
                tmp$1 = " (visible to TAN staff)";
                break;
            
          }
        } else {
          tmp$1 = "";
        }
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: locationDisplay
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Icon__Jsx3.make, {
                                    icon: "Lock",
                                    className: "text-gray-600 mr-1",
                                    size: 16
                                  }),
                              JsxRuntime.jsx(Tooltip.make, {
                                    label: address + tmp$1,
                                    children: JsxRuntime.jsx("div", {
                                          children: "Hidden Address",
                                          className: "border-dotted border-b border-gray-400"
                                        })
                                  })
                            ],
                            className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                          }),
                      className: "text-gray-600 text-lg"
                    })
              ]
            });
      }
      
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("div", {
                    children: address
                  }),
              JsxRuntime.jsx("div", {
                    children: locationDisplay,
                    className: "text-gray-600 text-lg"
                  })
            ]
          });
    }
    
  } else {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
                  children: locationDisplay
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Icon__Jsx3.make, {
                                icon: "Lock",
                                className: "text-gray-600 mr-1",
                                size: 16
                              }),
                          JsxRuntime.jsx("div", {
                                children: "Hidden Address"
                              })
                        ],
                        className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                      }),
                  className: "text-gray-600 text-lg"
                })
          ]
        });
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: tmp,
                    className: "flex flex-col gap-2 lg:gap-2 lg:flex-row items-baseline"
                  }),
              className: "text-gray-700 font-medium text-2xl lg:text-3xl"
            });
}

var Address = {
  make: AgentPropertyLocation$Address
};

function AgentPropertyLocation$ProPlanLabel(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "bg-tan-gold text-white px-2 py-1 text-base rounded font-semibold"
            });
}

var ProPlanLabel = {
  make: AgentPropertyLocation$ProPlanLabel
};

function AgentPropertyLocation$AddressFreePlan(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: props.locationDisplay
                          }),
                      className: "text-gray-700 font-medium text-2xl lg:text-3xl"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Address",
                              className: "text-zinc-500 tracking-wide  font-medium uppercase"
                            }),
                        JsxRuntime.jsx(AgentPropertyLocation$ProPlanLabel, {
                              children: "Pro Plan Only"
                            })
                      ],
                      className: "flex gap-1 flex-col items-baseline"
                    })
              ],
              className: "flex flex-col gap-2"
            });
}

var AddressFreePlan = {
  make: AgentPropertyLocation$AddressFreePlan
};

function AgentPropertyLocation$ByPropertyLocation(props) {
  var propertyLocation = use$1(props.propertyLocation);
  if (props.shouldShowPropertyDetails) {
    switch (propertyLocation.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          return JsxRuntime.jsx(AgentPropertyLocation$Address, {
                      locationDisplay: propertyLocation.locationDisplay
                    });
      case "PropertyLocationWithVisibleAddress" :
          return JsxRuntime.jsx(AgentPropertyLocation$Address, {
                      address: propertyLocation.address,
                      locationDisplay: propertyLocation.locationDisplay,
                      visibilityRule: propertyLocation.visibilityRule
                    });
      case "__unselected" :
          break;
      
    }
  } else {
    switch (propertyLocation.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          return JsxRuntime.jsx(AgentPropertyLocation$AddressFreePlan, {
                      locationDisplay: propertyLocation.locationDisplay
                    });
      case "PropertyLocationWithVisibleAddress" :
          return JsxRuntime.jsx(AgentPropertyLocation$AddressFreePlan, {
                      locationDisplay: propertyLocation.locationDisplay
                    });
      case "__unselected" :
          break;
      
    }
  }
  return UnselectedUnionMemberError.raise("Unselected property location " + propertyLocation._0);
}

var ByPropertyLocation = {
  make: AgentPropertyLocation$ByPropertyLocation
};

function AgentPropertyLocation$WithoutErrorBoundary(props) {
  var property = use(props.property);
  var shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  return JsxRuntime.jsx(AgentPropertyLocation$ByPropertyLocation, {
              propertyLocation: property.propertyLocation.fragmentRefs,
              shouldShowPropertyDetails: shouldShowPropertyDetails
            });
}

var WithoutErrorBoundary = {
  make: AgentPropertyLocation$WithoutErrorBoundary
};

function AgentPropertyLocation(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "location",
              children: JsxRuntime.jsx(AgentPropertyLocation$WithoutErrorBoundary, {
                    property: props.property
                  })
            });
}

var make = AgentPropertyLocation;

exports.PropertyFragment = PropertyFragment;
exports.PropertyLocationFragment = PropertyLocationFragment;
exports.Address = Address;
exports.ProPlanLabel = ProPlanLabel;
exports.AddressFreePlan = AddressFreePlan;
exports.ByPropertyLocation = ByPropertyLocation;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Tooltip Not a pure module */
